<template>
  <section class="carousel">
    <div id="heroControls" class="carousel slide" data-ride="carousel">
      <div class="carousel-inner">
        <div class="carousel-item active">
          <picture>
            <source
              media="(min-width:650px)"
              srcset="@/assets/como_usar_800.svg"
            />
            <source
              media="(min-width:465px)"
              srcset="@/assets/como_usar_360.svg"
              sizes="(min-width: 465px) 360px"
            />
            <img class="img-fluid" src="@/assets/como_usar_360.svg" alt="Como Usar" />
          </picture>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Carousel",
};
</script>

<style scoped>
ol.carousel-indicators li {
  background-color: white;
  height: 20px;
  width: 20px;
  border-radius: 30px;
  border: 0.6px solid black;
}

ol.carousel-indicators li.active {
  background: #dbf0fa;
}
</style>
